import {
    // COMMON
    Add, AddBox, AddCircle, Analytics, AnalyticsOutlined, ChevronRight, Clear, Close,
    ArrowBack, ArrowDownward, ArrowDropDown, ArrowDropUp, ArrowForward, ArrowRight,
    CheckCircle, ChevronLeft, KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowRight,
    KeyboardArrowUp, ArrowUpward, Comment, Delete, DeleteForever, DeleteOutlined,
    DoNotDisturb, Download, DownloadForOffline, DownloadOutlined, Downloading, Edit,
    EditOutlined, RadioButtonChecked, RadioButtonUnchecked, Filter, FilterAltOffRounded,
    FilterAltRounded, ViewList, Cancel, Check, CheckBox, CheckBoxOutlineBlank, OpenInNew,
    Visibility, VisibilityOff, Error, GridView, Info, InsertDriveFile, Remove, RemoveCircle,
    CalendarMonthOutlined, Search, Reply, Block, CenterFocusStrongOutlined, DeviceHub,
    DragIndicator, Folder, KeyboardVoice, PeopleAlt, PortraitOutlined, PortraitRounded,
    RateReview, Segment, Send, SplitscreenRounded, Stop, Subscriptions, SubscriptionsOutlined,
    SupervisedUserCircle, SupervisedUserCircleOutlined, TableRows, ThumbDown, ThumbDownOutlined,
    ThumbUp, ThumbUpOutlined, UploadFile, Videocam, Warning, Wc, ZoomIn, ZoomOut, AddCircleOutline,
    GraphicEqRounded,

    // SIDE DRAWER ICONS
    Api, ApiOutlined, Announcement, AnnouncementOutlined, Dashboard, DashboardOutlined,
    Assignment, AssignmentOutlined, Badge, BadgeOutlined, Category, CategoryOutlined,
    Description, DescriptionOutlined, DeveloperMode, DeveloperModeOutlined, OndemandVideo,
    OndemandVideoOutlined, ManageAccounts, ManageAccountsOutlined, Lock, LockOutlined,
    EmojiPeople, EmojiPeopleOutlined, Settings, SettingsOutlined, QuestionMark,
    QuestionMarkOutlined, Quiz, QuizOutlined, FiberManualRecord, FiberManualRecordOutlined,
    Home, HomeOutlined, Insights, InsightsOutlined, DynamicForm, DynamicFormOutlined,
    Feedback, FeedbackOutlined, NewReleases, NotificationsActiveOutlined, Rule, RuleOutlined,
    School, SchoolOutlined, PsychologyAlt, PsychologyAltOutlined, Replay, QuestionAnswer,
    QuestionAnswerOutlined, VideocamOutlined, ViewColumnOutlined, Terminal, TerminalOutlined,
    ViewQuilt, ViewQuiltOutlined, PlayCircleFilledWhite, PlayCircleFilledWhiteOutlined,
    AutoStories, AutoStoriesOutlined, LiveHelp, LiveHelpOutlined, CoPresentOutlined, CoPresent,


    // VIDEO PLAYER
    Forward10, VolumeDown, VolumeOff, VolumeUp, Pause, PlayArrow, Fullscreen, FullscreenExit,
    Replay10,
    Logout,
    SupportAgent,
    SupportAgentOutlined,
    DataObject,
    MeetingRoom,
    MeetingRoomOutlined,
    PersonRemove,
    PersonAdd,
    Login,
    OpenInFull,
    PushPin,
    PushPinOutlined,
    HighlightAlt,
    Workspaces,
    CancelPresentation,
    PresentToAll,
    MemoryOutlined,
    AccessTime,
    Cached,
    Groups,
    Groups2,
    FormatClear,
    Publish,
    MicOff,
    VideocamOff,
    MoreVert,
    EmojiEmotions,
    Mic,
    FrontHand,
    FrontHandOutlined,
    Checklist,
    AutoFixHigh,
    FilePresent,
    PaletteOutlined,
    DarkMode,
    LightMode,
    ComputerOutlined,
    SwapVertSharp,
    TrendingUp,
    Sync,
    Money,
    Scoreboard,
    LastPage,
    Menu,
    Person,
    Class,
    ClassOutlined,
    CopyAll,
    AdsClick,
    DomainAdd,
    UnfoldMore,
    Archive,
    Link,
    SpeakerNotes,
    CloudUploadOutlined,
    Group,
    Pets,
    Whatshot,
    History,
    Pending,
    TipsAndUpdates,
    FileUpload,
    TextFields,
    Movie,
    AccountBalance,
    AccountTree,
    AdminPanelSettings,
    AdminPanelSettingsOutlined,
    Sort,
    ArrowOutward,
    Storage,
    TheaterComedy,
    TheaterComedyOutlined,
    Dvr,
    DvrOutlined,
    MenuOpenOutlined,
    Campaign,
    ReportOutlined,
    Share,
    Ballot,
    ChatBubble,
    CastForEducation,
    CastForEducationOutlined,
    Cast,
    CastConnected,
    Devices,
    CheckCircleOutlined,
    Speed,
    Wifi,
    Engineering,
    EngineeringOutlined,
    EmojiEvents,
    Height,
    Crop169,
    CropPortrait,
    CropLandscape,
    CropSquare,

} from '@mui/icons-material'
import { CrownIcon, DocumentIcon, MaterialIcon, PDFIcon, SubjectIcon, VideoIcon } from '../assets/custom-icons'

// IMAGES: FILE ICONS
import pngThumb from '../../src/assets/png-logo.svg'
import jpgThumb from '../../src/assets/jpg-logo.svg'
import tiffThumb from '../../src/assets/png-logo.svg'
import pdfThumb from '../../src/assets/pdf-logo.svg'
import wordThumb from '../../src/assets/word-logo.svg'
import excelThumb from '../../src/assets/excel-logo.svg'
import fileThumb from '../../src/assets/file-logo.svg'
import pptThumb from '../../src/assets/ppt-logo.svg'
import videoThumb from '../../src/assets/videofile-logo.svg'
import writeXlsxFile from 'write-excel-file'

// IMAGES: MEETING VIRTUAL BG IMAGES
import meetingBg1 from '../assets/meeting-vbgs/bg1.jpg'
import meetingBg2 from '../assets/meeting-vbgs/bg2.jpg'
import meetingBg3 from '../assets/meeting-vbgs/bg3.jpg'
import meetingBg4 from '../assets/meeting-vbgs/bg4.jpg'

// IMAGES: THUMBNAILS
import examDefault1 from '../assets/default-exam-thumb.jpg'
import examDefault2 from '../assets/default-exam-thumb.png'
import assignmentDefault1 from '../assets/assignment-default-thumb.jpg'
import assignmentDefault2 from '../assets/assignment-default-thumb2.jpg'
import discussionDefault1 from '../assets/discussion-default-thumb.jpg'
import discussionDefault2 from '../assets/discussion-default-thumb2.jpg'
import discussionDefault3 from '../assets/discussion-default-thumb3.jpg'
import studyMaterialDefault1 from '../assets/study-material-default-thumb.jpg'
import studyMaterialDefault2 from '../assets/study-material-default-thumb2.jpg'
import studyMaterialDefault3 from '../assets/study-material-default-thumb4.jpg'
import livesessionsDefault1 from '../assets/live-sessions-default-thumb.jpg'
import livesessionsDefault2 from '../assets/live-sessions-default-thumb2.jpg'
import livesessionsDefault3 from '../assets/live-sessions-default-thumb3.jpg'
import defaultOnlineCourseThumb1 from '../../src/assets/default-thumb-1.svg'
import defaultOnlineCourseThumb2 from '../../src/assets/default-thumb-2.svg'
import defaultOnlineCourseThumb3 from '../../src/assets/default-thumb-3.svg'

import dayjs from 'dayjs'
import { toast } from 'react-toastify'

const FileIcon = (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M8.89028 30.3569H23.1131C25.8857 30.3569 27.2651 28.9643 27.2651 26.1649V5.84772C27.2651 3.06201 25.8857 1.64258 23.1131 1.64258H8.89028C6.13142 1.64258 4.73828 3.06201 4.73828 5.84829V26.1649C4.73828 28.9637 6.13142 30.3569 8.89028 30.3569ZM8.99714 28.2009C7.61771 28.2009 6.89428 27.4637 6.89428 26.1249V5.88829C6.89428 4.56258 7.61771 3.79858 9.01085 3.79858H23.0063C24.3989 3.79858 25.1091 4.54886 25.1091 5.88829V26.1249C25.1091 27.4637 24.3989 28.2009 23.0194 28.2009H8.99714ZM10.9394 9.39686H21.0909C21.5594 9.39686 21.9211 9.02201 21.9211 8.55344C21.9211 8.09801 21.56 7.75001 21.0909 7.75001H10.9394C10.4434 7.75001 10.0954 8.09801 10.0954 8.55344C10.0954 9.02201 10.444 9.39686 10.9394 9.39686ZM10.9394 14.0711H21.0909C21.5594 14.0711 21.9211 13.6963 21.9211 13.2272C21.9211 12.7723 21.56 12.4237 21.0909 12.4237H10.9394C10.4434 12.4237 10.0954 12.7723 10.0954 13.2272C10.0954 13.6957 10.444 14.0711 10.9394 14.0711ZM10.9394 18.7454H15.7474C16.216 18.7454 16.5777 18.3837 16.5777 17.9283C16.5777 17.4597 16.216 17.098 15.7474 17.098H10.9389C10.4429 17.098 10.0949 17.4597 10.0949 17.9283C10.0949 18.3837 10.4434 18.7454 10.9389 18.7454' fill='currentColor' />
    </svg>
)

// CONSTS
export const ERPLoginPageURL = 'https://www.acharyaerptech.in/Login'
export const ERPDashboardPageURL = 'https://www.acharyaerptech.in/Dashboard'
export const ALIVE_SUPPORT_URL = 'https://support.alive.university'

const iconProps = {
    sx: {
        color: "inherit", fontSize: "inherit"
    }
}

export const Icons = {}
Icons.default = {
    CropSquare: <CropSquare  {...iconProps} />,
    CropLandscape: <CropLandscape  {...iconProps} />,
    CropPortrait: <CropPortrait  {...iconProps} />,
    Crop169: <Crop169  {...iconProps} />,
    Height: <Height  {...iconProps} />,
    EmojiEvents: <EmojiEvents  {...iconProps} />,
    SpeedIcon: <Speed  {...iconProps} />,
    Wifi: <Wifi  {...iconProps} />,
    EngineeringOutlined: <EngineeringOutlined  {...iconProps} />,
    Engineering: <Engineering  {...iconProps} />,
    ReportOutlined: <ReportOutlined  {...iconProps} />,
    AnnouncementMic: <Campaign  {...iconProps} />,
    Devices: <Devices {...iconProps} />,
    Stream: <Cast {...iconProps} />,
    Streamimg: <CastConnected {...iconProps} />,
    HybridClasses: <CastForEducation {...iconProps} />,
    HybridClassesOutlined: <CastForEducationOutlined {...iconProps} />,
    ChatBubble: <ChatBubble {...iconProps} />,
    Ballot: <Ballot  {...iconProps} />,
    Share: <Share  {...iconProps} />,
    Storage: <Storage  {...iconProps} />,
    ArrowOutward: <ArrowOutward  {...iconProps} />,
    Sort2: <Sort  {...iconProps} />,
    MenuClose: <MenuOpenOutlined  {...iconProps} />,
    AdminActivity: <Dvr  {...iconProps} />,
    AdminActivityOutlined: <DvrOutlined  {...iconProps} />,
    Impersonation: <TheaterComedy  {...iconProps} />,
    ImpersonationOutlined: <TheaterComedyOutlined  {...iconProps} />,
    ModulePermissions: <AdminPanelSettings  {...iconProps} />,
    ModulePermissionsOutlined: <AdminPanelSettingsOutlined  {...iconProps} />,
    Branches: <AccountTree  {...iconProps} />,
    Building1: <AccountBalance  {...iconProps} />,
    SupervisedUserCircle: <SupervisedUserCircle  {...iconProps} />,
    Movie: <Movie  {...iconProps} />,
    Upload: <FileUpload {...iconProps} />,
    AskAI: <TipsAndUpdates {...iconProps} />,
    Pending: <Pending {...iconProps} />,
    History: <History {...iconProps} />,
    Trending2: <Whatshot {...iconProps} />,
    Simba: <Pets {...iconProps} />,
    People: <Group {...iconProps} />,
    QuizModule: <SpeakerNotes {...iconProps} />,
    CloudUpload: <CloudUploadOutlined {...iconProps} />,
    File: <InsertDriveFile {...iconProps} />,
    Text: <TextFields  {...iconProps} />,
    RemoveFormat: <FormatClear  {...iconProps} />,
    Archive: <Archive {...iconProps} />,
    Link: <Link {...iconProps} />,
    UnfoldMore: <UnfoldMore {...iconProps} />,
    DomailAdd: <DomainAdd {...iconProps} />,
    Click: <AdsClick {...iconProps} />,
    Copy: <CopyAll {...iconProps} />,
    Class: <Class {...iconProps} />,
    ClassOutlined: <ClassOutlined {...iconProps} />,
    User: <Person {...iconProps} />,
    Menu: <Menu {...iconProps} />,
    Last: <LastPage {...iconProps} />,
    ScoreBoard: <Scoreboard {...iconProps} />,
    Money: <Money {...iconProps} />,
    Sync: <Sync {...iconProps} />,
    TrendingUp: <TrendingUp {...iconProps} />,
    Group: <Groups  {...iconProps} />,
    Sort: <SwapVertSharp {...iconProps} />,
    Clock: <AccessTime {...iconProps} />,
    SystemTheme: <ComputerOutlined   {...iconProps} />,
    DarkMode: <DarkMode   {...iconProps} />,
    LightMode: <LightMode   {...iconProps} />,
    PaletteOutlined: <PaletteOutlined  {...iconProps} />,
    FilePresent: <FilePresent {...iconProps} />,
    MoreVert: <MoreVert {...iconProps} />,
    PresentToAll: <PresentToAll {...iconProps} />,
    EmojiEmotions: <EmojiEmotions {...iconProps} />,
    Mic: <Mic {...iconProps} />,
    FrontHand: <FrontHand {...iconProps} />,
    FrontHandOutlined: <FrontHandOutlined {...iconProps} />,
    Checklist: <Checklist {...iconProps} />,
    AutoFixHigh: <AutoFixHigh {...iconProps} />,
    Publish: <Publish {...iconProps} />,
    CancelPresentation: <CancelPresentation {...iconProps} />,
    MicOff: <MicOff {...iconProps} />,
    VideocamOff: <VideocamOff {...iconProps} />,
    OpenInFull: <OpenInFull {...iconProps} />,
    PushPin: <PushPin {...iconProps} />,
    PushPinOutlined: <PushPinOutlined {...iconProps} />,
    PersonAdd: <PersonAdd {...iconProps} />,
    PersonRemove: <PersonRemove {...iconProps} />,
    Login: <Login {...iconProps} />,
    Info: <Info {...iconProps} />,
    MeetingRooms: <MeetingRoom {...iconProps} />,
    MeetingRoomsOutlined: <MeetingRoomOutlined {...iconProps} />,
    CodeLab: <DataObject {...iconProps} />,
    GraphicEqRounded: <GraphicEqRounded {...iconProps} />,
    SupportAgent: <SupportAgent {...iconProps} />,
    SupportAgentOutlined: <SupportAgentOutlined {...iconProps} />,
    Logout: <Logout {...iconProps} />,
    Terminal: <Terminal {...iconProps} />,
    TerminalOutlined: <TerminalOutlined {...iconProps} />,
    ZoomIn: <ZoomIn {...iconProps} />,
    ZoomOut: <ZoomOut {...iconProps} />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined {...iconProps} />,
    Announcement: <Announcement {...iconProps} />,
    AnnouncementOutlined: <AnnouncementOutlined {...iconProps} />,
    Replay: <Replay {...iconProps} />,
    CheckboxChecked: <CheckBox {...iconProps} />,
    RadioUnchecked: <RadioButtonUnchecked {...iconProps} />,
    RadioChecked: <RadioButtonChecked {...iconProps} />,
    PsychologyAlt: <PsychologyAlt {...iconProps} />,
    PsychologyAltOutlined: <PsychologyAltOutlined {...iconProps} />,
    TemporaryUsersOutlined: <SupervisedUserCircleOutlined {...iconProps} />,
    TemporaryUsers: <SupervisedUserCircle {...iconProps} />,
    Books: <Class {...iconProps} />,
    FileIcon,
    Crown: <img {...iconProps} src={CrownIcon} alt='Crown' />,
    Calendar: <CalendarMonthOutlined {...iconProps} />,
    Subject: <img {...iconProps} src={SubjectIcon} alt='Subject' />,
    Material: <img {...iconProps} src={MaterialIcon} alt='Material' />,
    Document: <img {...iconProps} src={DocumentIcon} alt='Document' />,
    PDF: <img {...iconProps} src={PDFIcon} alt='pdf' />,
    Video: <img {...iconProps} src={VideoIcon} alt='video' />,
    NotificationsOutlined: <NotificationsActiveOutlined {...iconProps} />,
    ArrowForward: <ArrowForward {...iconProps} />,
    ManageAccounts: <ManageAccounts {...iconProps} />,
    ManageAccountsOutlined: <ManageAccountsOutlined {...iconProps} />,
    Entity: <Category {...iconProps} />,
    EntityOutlined: <CategoryOutlined {...iconProps} />,
    Templates: <ViewQuilt {...iconProps} />,
    TemplatesOutlined: <ViewQuiltOutlined {...iconProps} />,
    Form: <DynamicForm {...iconProps} />,
    FormOutlined: <DynamicFormOutlined {...iconProps} />,
    Api: <Api {...iconProps} />,
    ApiOutlined: <ApiOutlined {...iconProps} />,
    Auditor: <SupervisedUserCircle {...iconProps} />,
    AuditorOutlined: <SupervisedUserCircleOutlined {...iconProps} />,
    Rule: <Rule {...iconProps} />,
    RuleOutlined: <RuleOutlined {...iconProps} />,
    KeyBoardArrowRight: <KeyboardArrowRight {...iconProps} />,
    KeyBoardArrowLeft: <KeyboardArrowLeft {...iconProps} />,
    ArrowRight: <ArrowRight {...iconProps} />,
    Dashboard: <Dashboard {...iconProps} />,
    DashboardOutlined: <DashboardOutlined {...iconProps} />,
    Subjects: <AutoStories {...iconProps} />,
    SubjectsOutlined: <AutoStoriesOutlined {...iconProps} />,
    Course: <CoPresent {...iconProps} />,
    CourseOutlined: <CoPresentOutlined {...iconProps} />,
    Subscriptions: <Subscriptions {...iconProps} />,
    SubscriptionsOutlined: <SubscriptionsOutlined {...iconProps} />,
    Badge: <Badge {...iconProps} />,
    BadgeOutlined: <BadgeOutlined {...iconProps} />,
    QuestionMark: <QuestionMark {...iconProps} />,
    QuestionMarkOutlined: <QuestionMarkOutlined {...iconProps} />,
    Discussions: <QuestionAnswer {...iconProps} />,
    DiscussionsOutlined: <QuestionAnswerOutlined {...iconProps} />,
    Category: <CategoryOutlined {...iconProps} />,
    Reply: <Reply {...iconProps} />,
    Like: <ThumbUp {...iconProps} />,
    LikeOutlined: <ThumbUpOutlined {...iconProps} />,
    Unlike: <ThumbDown {...iconProps} />,
    UnlikeOutlined: <ThumbDownOutlined {...iconProps} />,
    DropDown: <ArrowDropDown {...iconProps} />,
    DropUp: <ArrowDropUp {...iconProps} />,
    Send: <Send {...iconProps} />,
    Comment: <Comment {...iconProps} />,
    FilterAlt: <FilterAltRounded {...iconProps} />,
    FilterAltOff: <FilterAltOffRounded {...iconProps} />,
    Warning: <Warning {...iconProps} />,
    Filter: <Filter {...iconProps} />,
    DoNotDisturb: <DoNotDisturb {...iconProps} />,
    School: <School {...iconProps} />,
    SchoolOutlined: <SchoolOutlined {...iconProps} />,
    Stop: <Stop {...iconProps} />,
    AudioRecorder: <KeyboardVoice {...iconProps} />,
    ArrowBack: <ArrowBack {...iconProps} />,
    Checkbox: <CheckBoxOutlineBlank {...iconProps} />,
    Rows: <TableRows {...iconProps} />,
    AddBox: <AddBox {...iconProps} />,
    Settings: <Settings {...iconProps} />,
    SettingsOutlined: <SettingsOutlined {...iconProps} />,
    ArrowDownward: <ArrowDownward {...iconProps} />,
    ArrowUpward: <ArrowUpward {...iconProps} />,
    KeyboardArrowUp: <KeyboardArrowUp {...iconProps} />,
    ViewColumnRounded: <ViewColumnOutlined {...iconProps} />,
    AddCircleOutlined: <AddCircleOutline {...iconProps} />,
    AddCircleIcon: <AddCircle {...iconProps} />,
    DragIndicatorIcon: <DragIndicator {...iconProps} />,
    SplitScreen: <SplitscreenRounded {...iconProps} />,
    Protrait: <PortraitRounded {...iconProps} />,
    ProtraitOutlined: <PortraitOutlined {...iconProps} />,
    KeyboardArrowDownIcon: <KeyboardArrowDown {...iconProps} />,
    FullscreenIcon: <Fullscreen {...iconProps} />,
    FullscreenExitIcon: <FullscreenExit {...iconProps} />,
    VolumeOffIcon: <VolumeOff {...iconProps} />,
    VolumeDownIcon: <VolumeDown {...iconProps} />,
    VolumeUpIcon: <VolumeUp {...iconProps} />,
    PlayArrowIcon: <PlayArrow {...iconProps} />,
    PauseIcon: <Pause {...iconProps} />,
    Forward10Icon: <Forward10 {...iconProps} />,
    Replay10Icon: <Replay10 {...iconProps} />,
    InsightsIcon: <Insights {...iconProps} />,
    InsightsIconOutlined: <InsightsOutlined {...iconProps} />,
    GridViewIcon: <GridView {...iconProps} />,
    SegmentView: <Segment {...iconProps} />,
    ViewListIcon: <ViewList {...iconProps} />,
    LiveHelpIcon: <LiveHelp {...iconProps} />,
    LiveHelpIconOutlined: <LiveHelpOutlined {...iconProps} />,
    InsertDriveFileIcon: <InsertDriveFile {...iconProps} />,
    RemoveIcon: <Remove {...iconProps} />,
    DownloadingIcon: <Downloading {...iconProps} />,
    FolderIcon: <Folder {...iconProps} />,
    CheckIcon: <Check {...iconProps} />,
    QuizIcon: <Quiz {...iconProps} />,
    QuizIconOutlined: <QuizOutlined {...iconProps} />,
    RemoveCircleIcon: <RemoveCircle {...iconProps} />,
    NewReleasesIcon: <NewReleases {...iconProps} />,
    PlayCircleFilledWhiteIcon: <PlayCircleFilledWhite {...iconProps} />,
    PlayCircleFilledWhiteIconOutlined: <PlayCircleFilledWhiteOutlined {...iconProps} />,
    FiberManualRecordIcon: <FiberManualRecord {...iconProps} />,
    FiberManualRecordIconOutlined: <FiberManualRecordOutlined {...iconProps} />,
    UploadFileIcon: <UploadFile {...iconProps} />,
    EmojiPeopleIcon: <EmojiPeople {...iconProps} />,
    EmojiPeopleIconOutlined: <EmojiPeopleOutlined {...iconProps} />,
    ErrorIcon: <Error {...iconProps} />,
    ClearIcon: <Clear {...iconProps} />,
    BlockIcon: <Block {...iconProps} />,
    CheckCircleIcon: <CheckCircle {...iconProps} />,
    CheckCircleIconOutlined: <CheckCircleOutlined {...iconProps} />,
    EditIcon: <Edit {...iconProps} />,
    EditIconOutlined: <EditOutlined {...iconProps} />,
    AssignmentIcon: <Assignment {...iconProps} />,
    AssignmentIconOutlined: <AssignmentOutlined {...iconProps} />,
    DescriptionIcon: <Description {...iconProps} />,
    DescriptionIconOutlined: <DescriptionOutlined {...iconProps} />,
    DeviceHubIcon: <DeviceHub {...iconProps} />,
    PeopleAltIcon: <PeopleAlt {...iconProps} />,
    WcIcon: <Wc {...iconProps} />,
    SearchIcon: <Search {...iconProps} />,
    AddIcon: <Add {...iconProps} />,
    RateReviewIcon: <RateReview {...iconProps} />,
    DeleteIcon: <Delete {...iconProps} />,
    DeleteIconOutlined: <DeleteOutlined {...iconProps} />,
    VisibilityIcon: <Visibility {...iconProps} />,
    VisibilityOffIcon: <VisibilityOff {...iconProps} />,
    OndemandVideoIcon: <OndemandVideo {...iconProps} />,
    OndemandVideoIconOutlined: <OndemandVideoOutlined {...iconProps} />,
    FeedbackIcon: <Feedback {...iconProps} />,
    FeedbackIconOutlined: <FeedbackOutlined {...iconProps} />,
    HomeIcon: <Home {...iconProps} />,
    HomeIconOutlined: <HomeOutlined {...iconProps} />,
    DeveloperModeIcon: <DeveloperMode {...iconProps} />,
    DeveloperModeIconOutlined: <DeveloperModeOutlined {...iconProps} />,
    LockIcon: <Lock {...iconProps} />,
    LockIconOutlined: <LockOutlined {...iconProps} />,
    AnalyticsIcon: <Analytics {...iconProps} />,
    AnalyticsIconOutlined: <AnalyticsOutlined {...iconProps} />,
    CloseIcon: <Close {...iconProps} />,
    VideocamIcon: <Videocam {...iconProps} />,
    VideocamIconOutlined: <VideocamOutlined {...iconProps} />,
    ChevronLeftIcon: <ChevronLeft {...iconProps} />,
    ChevronRightIcon: <ChevronRight {...iconProps} />,
    CancelIcon: <Cancel {...iconProps} />,
    DownloadForOfflineIcon: <DownloadForOffline {...iconProps} />,
    DownloadIcon: <Download {...iconProps} />,
    DownloadIconOutlined: <DownloadOutlined {...iconProps} />,
    OpenInNewIcon: <OpenInNew {...iconProps} />,
    DeleteForever: <DeleteForever {...iconProps} />,
}

Icons.small = {
    Checklist: <Checklist fontSize='small' {...iconProps} />,
    Selection: <HighlightAlt fontSize='small' {...iconProps} />,
    Badge: <Badge fontSize='small' {...iconProps} />,
    FullscreenExitIcon: <FullscreenExit fontSize='small' {...iconProps} />,
    FullscreenIcon: <Fullscreen fontSize='small' {...iconProps} />,
    Workspaces: <Workspaces fontSize='small' {...iconProps} />,
    // CancelReview: <DisabledVisible fontSize="small" {...iconProps} />,
    StopPresenting: <CancelPresentation fontSize='small' {...iconProps} />,
    Present: <PresentToAll fontSize='small' {...iconProps} />,
    Memory: <MemoryOutlined fontSize='small' {...iconProps} />,
    Clock: <AccessTime fontSize='small' {...iconProps} />,
    Settings: <SettingsOutlined fontSize='small' {...iconProps} />,
    ArrowBack: <ArrowBack fontSize='small' {...iconProps} />,
    Refresh: <Cached fontSize='small' {...iconProps} />,
    Groups: <Groups fontSize='small' {...iconProps} />,
    Groups2: <Groups2 fontSize='small' {...iconProps} />,
    Folder: <Folder fontSize='small' {...iconProps} />,
    FormatClear: <FormatClear fontSize='small' {...iconProps} />,
    KeyBoardArrowRight: <KeyboardArrowRight fontSize='small' {...iconProps} />,
    KeyBoardArrowLeft: <KeyboardArrowLeft fontSize='small' {...iconProps} />,
    GraphicEqRounded: <GraphicEqRounded fontSize='small' {...iconProps} />,
    KeyboardArrowUp: <KeyboardArrowUp {...iconProps} fontSize='small' />,
    SearchIcon: <Search {...iconProps} fontSize='small' />,
    ZoomIn: <ZoomIn {...iconProps} fontSize='small' />,
    ZoomOut: <ZoomOut {...iconProps} fontSize='small' />,
    CenterFocusStrongOutlined: <CenterFocusStrongOutlined {...iconProps} fontSize='small' />,
    InfoIcon: <Info {...iconProps} fontSize='small' />,
    VisibilityIcon: <Visibility {...iconProps} fontSize='small' />,
    OpenInNewIcon: <OpenInNew {...iconProps} fontSize='small' />,
    CloseIcon: <Close {...iconProps} fontSize='small' />,
    Crown: <img src={CrownIcon} width='20px' alt='Crown small' />,
    Subject: <img width='20px' src={SubjectIcon} alt='Subject small' />,
    KeyboardArrowDown: <KeyboardArrowDown {...iconProps} fontSize='small' />,
    Category: <CategoryOutlined {...iconProps} fontSize='small' />,
    DropDown: <ArrowDropDown {...iconProps} fontSize='small' />,
    ChevronLeftIcon: <ChevronLeft {...iconProps} fontSize='small' />,
    ChevronRightIcon: <ChevronRight {...iconProps} fontSize='small' />,
    VolumeOffIcon: <VolumeOff {...iconProps} fontSize='small' />,
    VolumeDownIcon: <VolumeDown {...iconProps} fontSize='small' />,
    VolumeUpIcon: <VolumeUp {...iconProps} fontSize='small' />,
    DownloadIcon: <DownloadOutlined {...iconProps} fontSize='small' />,
    DeleteIcon: <DeleteOutlined {...iconProps} fontSize='small' />,
    EditIcon: <Edit {...iconProps} fontSize='small' />,
}

export const ASSIGNMENT_CONVERT_DUE_TIME_BEFORE = '2026-01-20T18:30:00.000Z'

export const ACHARYA_EMAIL_PATTERN = /(([a-z0-9.]+)@acharya.ac.in)+/

export const SPACES_LOCATION_REGEXP = /(https:\/\/(?<bucket>[a-z-]+)\.)?(?<region>[a-zA-Z0-9]+)\.(cdn\.)?digitaloceanspaces\.com\/(?<key>(?<folder>[a-zA-Z_/-]+)\/(?<filesavedfullname>(\d{10,}\.)?(?<filefullname>[.a-zA-Z0-9@%()_-\s]+\.(?<fileextention>\w+))))\/?/

export const CHIP_COLORS = ['#49982E', '#FF9053', '#353297', '#00ABE4', '#5E2974']
export const EXAM_CARD_COLORS = ['#FFDF8C', '#D6FFA6', '#A7DAFF']

export const FLAT_LIGHT_COLORS = ['#DBFFD4', '#D5F0FF', '#FFE0E4', '#b2dfdb', '#e6ee9c', '#c5e1a5', '#a5d6a7', '#ffcc80', '#ffe082', '#ffccbc']

export const FLAT_COLORS = ['#f7514d', '#1FC439', '#C54097', '#49982E', '#933df5']

export const ALPHABETS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

export const RED_SHADE_TABLE_HIGHLIGHT_COLOR = "#FCE4D6"

export const EMPTY_OBJECT = {}
export const EMPTY_ARRAY = []

export const POLL_OPTIONS_COLORS = [
    "#3498db", // Blue
    "#e67e22", // Orange
    "#2ecc71", // Green
    "#9b59b6", // Purple
    "#f1c40f", // Yellow
    "#1abc9c", // Teal
    "#e74c3c", // Red
    "#34495e", // Dark Blue-gray
    "#fd79a8", // Pink
    "#00cec9", // Cyan
    "#e84393", // Deep Pink
    "#6c5ce7", // Indigo
    "#d35400", // Dark Orange
    "#27ae60", // Emerald
    "#2980b9", // Darker Blue
    "#16a085", // Dark Teal
    "#f39c12", // Yellow Orange
    "#c0392b", // Dark Red
    "#7f8c8d", // Gray
    "#8e44ad", // Dark Purple
]

export const USER_CARD_COLOR_SETS = [
    {
        gradient: "radial-gradient(circle, #692591, #9e2e91)",
        gradientColors: ["#692591", "#9e2e91"],
        primary: "#5902b7",
    },
    {
        gradient: "radial-gradient(circle, #e67151, #e0792a)",
        gradientColors: ["#e67151", "#e0792a"],
        primary: "#d84315",
    },
    {
        gradient: "radial-gradient(circle, #5c2ec4, #2b56d6)",
        gradientColors: ["#5c2ec4", "#2b56d6"],
        primary: "#4527a0",
    },
    {
        gradient: "radial-gradient(circle, #f08a93, #c0374e)",
        gradientColors: ["#f08a93", "#c0374e"],
        primary: "#c2185b",
    },
    {
        gradient: "radial-gradient(circle, #276fa6, #204980)",
        gradientColors: ["#276fa6", "#204980"],
        primary: "#1976d2",
    },
    {
        gradient: "radial-gradient(circle, #802085, #26317b)",
        gradientColors: ["#802085", "#26317b"],
        primary: "#8e24aa",
    },
    {
        gradient: "radial-gradient(circle, #ef943a, #ca5114)",
        gradientColors: ["#ef943a", "#ca5114"],
        primary: "#a34c04",
    },
    {
        gradient: "radial-gradient(circle, #309d84, #00695c)",
        gradientColors: ["#309d84", "#00695c"],
        primary: "#00695c",
    },
    {
        gradient: "radial-gradient(circle, #ce7385, #ad314a)",
        gradientColors: ["#ce7385", "#ad314a"],
        primary: "#ad1457",
    },
    {
        gradient: "radial-gradient(circle, #44c2cf, #362c7a)",
        gradientColors: ["#44c2cf", "#362c7a"],
        primary: "#00838f",
    },
    {
        gradient: "radial-gradient(circle, #f7a93d, #a88512)",
        gradientColors: ["#f7a93d", "#a88512"],
        primary: "#a08912",
    },
    {
        gradient: "radial-gradient(circle, #c54d6f, #403480)",
        gradientColors: ["#c54d6f", "#403480"],
        primary: "#880e4f",
    },
    {
        gradient: "radial-gradient(circle, #c24646, #2d5aa6)",
        gradientColors: ["#c24646", "#2d5aa6"],
        primary: "#8e0000",
    },
    {
        gradient: "radial-gradient(circle, #ff7a26, #c4326f)",
        gradientColors: ["#ff7a26", "#c4326f"],
        primary: "#e64a19",
    },
    {
        gradient: "radial-gradient(circle, #6cb94e, #2e7d32)",
        gradientColors: ["#6cb94e", "#2e7d32"],
        primary: "#2e7d32",
    },
    {
        gradient: "radial-gradient(circle, #6b4e91, #505d87)",
        gradientColors: ["#6b4e91", "#505d87"],
        primary: "#4527a0",
    },
    {
        gradient: "radial-gradient(circle, #32b7b8, #00a89c)",
        gradientColors: ["#32b7b8", "#00a89c"],
        primary: "#00796b",
    },
    {
        gradient: "radial-gradient(circle, #f15d4a, #d93772)",
        gradientColors: ["#f15d4a", "#d93772"],
        primary: "#c62828",
    },
    {
        gradient: "radial-gradient(circle, #29b0f5, #1560d1)",
        gradientColors: ["#29b0f5", "#1560d1"],
        primary: "#1565c0",
    },
    {
        gradient: "radial-gradient(circle, #e5b981, #8d6e63)",
        gradientColors: ["#e5b981", "#8d6e63"],
        primary: "#8d6e63",
    },
]

export const MEETINGS_VIRTUAL_BACKGROUNDS = [
    { id: 1, src: meetingBg1, label: "Living Room" },
    { id: 2, src: meetingBg2, label: "Plane Wing" },
    { id: 3, src: meetingBg3, label: "Cafe" },
    { id: 4, src: meetingBg4, label: "Library" },
]


export const AUDIT_COUNT_CARD_COLORS = [
    { bg: '#0DCAF04D', circleColor: '#0DCAF0' },
    { bg: '#DC35454D', circleColor: '#DC3545' },
    { bg: '#1987544D', circleColor: '#198754' },
    { bg: '#0D6EFD4D', circleColor: '#0D6EFD' },
    { bg: '#FFC1584D', circleColor: '#FFC158' },
]

export const FLAT_COLORS_WITH_BACKGROUND = [
    { bg: '#DAFFD4', color: '#1FC439' },
    { bg: '#FFD9CB', color: '#E25A26' },
    { bg: '#FFEBFF', color: '#5E2974' },
    { bg: '#FFDAFE', color: '#A200E5' },
    { bg: '#FFE3E2', color: '#FF3E39' },
    { bg: '#CCE1EF', color: '#139CFF' },
    { bg: '#FED7FD', color: '#C54097' },
    { bg: '#FFDBCD', color: '#FF7641' },
]

export const FLAT_GRADIENTS = [
    {
        background: 'linear-gradient( 90deg,rgb(56, 90, 239),rgb(63, 87, 160) )',
        color: 'white',
    },
    {
        background: 'linear-gradient( 90deg, #e57373, #db7093 )',
        color: 'white',
    },

    {
        background: 'linear-gradient( 90deg, #729bff, #8bbdff )',
        color: 'black',
    },

    {
        background: 'linear-gradient( 90deg, #8fbc53, #69a065 )',
        color: 'black',
    },

    {
        background: 'linear-gradient( 90deg, #1a6d89, #5ba6d6 )',
        color: 'white',
    },

    {
        background: 'linear-gradient( 90deg, #d190b4, #7985c9 )',
        color: 'white',
    },

    {
        background: 'linear-gradient( 90deg, #e6ba91, #e08d72 )',
        color: 'black',
    },

    {
        background: 'linear-gradient( 90deg, #99a8b6, #d3dde1 )',
        color: 'black',
    },

    {
        background: 'linear-gradient( 90deg, #d7aa3b, #db8358 )',
        color: 'black',
    },

    {
        background: 'linear-gradient( 90deg, #5159b8, #604191 )',
        color: 'white',
    },

    {
        background: 'linear-gradient( 90deg, #f1bd68, #9bd3e2 )',
        color: 'black',
    },
]

export const CALENDAR_COLORS = {
    offlineDark: '#ff823f',
    offlineLight: '#ffdac5',
    todayCalendarDateColor: '#3F5EFF',
    onlineLight: 'rgba(16, 185, 129,0.6)',
    onlineDark: 'linear-gradient(to right, rgb(5, 150, 105) 65%,rgb(16, 185, 129))',
    onlineBorder: 'rgb(5, 150, 105)',
    offlineBorder: '#ff823f',
    greyed: '#ffffff44',
}

export const defaultFeedThumbs = {
    exam: [],
    assignment: [],
    discussion: [],
    'study material': [],
}

export const attachmentThumbnails = {
    png: pngThumb,
    jpg: jpgThumb,
    jpeg: jpgThumb,
    tiff: tiffThumb,
    pdf: pdfThumb,
    docx: wordThumb,
    xls: excelThumb,
    xlsx: excelThumb,
    default: fileThumb,
    pptx: pptThumb,
    mp4: videoThumb,
    wepm: videoThumb,
    ppsx: pptThumb,
}

export const defaultOnlineCourseThumbs = [defaultOnlineCourseThumb1, defaultOnlineCourseThumb2, defaultOnlineCourseThumb3]

export const feedDefaultThumbs = {
    exam: [examDefault1, examDefault2],
    quiz: [examDefault1, examDefault2],
    assignment: [assignmentDefault1, assignmentDefault2],
    discussion: [discussionDefault1, discussionDefault2, discussionDefault3],
    'study material': [studyMaterialDefault1, studyMaterialDefault2, studyMaterialDefault3],
    'live session': [livesessionsDefault1, livesessionsDefault2, livesessionsDefault3],
}

export const latexDelimiters = [
    { left: '$$', right: '$$', display: true },
    { left: '\\(', right: '\\)', display: false },
    { left: '$', right: '$', display: false },
    { left: '\\[', right: '\\]', display: true },
]

export const quillDefaultModule = {
    toolbar: {
        container: [
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ size: ['normal', 'small', 'large'] }],
            [{ align: [] }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean'],
            ['code-block'],
        ]
    },
}

export const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thrusday', 'Friday', 'Saturday', 'Sunday']
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const WEEK_DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
export const HOURS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
export const DOC_VIEWER_SUPPORTED_FORMATS = ['mp4', 'webm', 'ogg', 'mp3', 'bmp', 'jpg', 'jpeg', 'docx', 'html', 'htm', 'doc', 'pdf', 'png', 'ppt', 'pptx', 'tiff', 'txt', 'xls', 'xlsx']

export const getNameInitials = ( name ) => {
    try {
        const nameParts = name?.split( " " )
        return nameParts.map( n => n?.at( 0 ) ).slice( 0, 2 )
    } catch ( err ) {
        return name?.at( 0 )
    }
}

export const isReactComponent = ( value ) => {
    return (
        typeof value === 'function' ||
        ( value && typeof value === 'object' && value.$$typeof === Symbol.for( 'react.element' ) )
    )
}

export const getGroupChipLabel = groupDetails => {
    if ( groupDetails.entity === 'batch' || groupDetails.batch_assignment_id ) {
        return groupDetails.chip_label || `Batch: ${groupDetails.batch_name}${groupDetails.remarks ? `, ${groupDetails.remarks}` : "Remarks: Not given."}`
    }
    if ( groupDetails.entity === 'section' || groupDetails.section_assignment_id ) {
        return groupDetails.chip_label || `Section: ${groupDetails.section_short_name} `
    }
    return ""
}

export const getTransformedGroupDetails = group => {
    if ( group?.entity === 'batch' || group?.batch_assignment_id ) {
        const batch = { ...group }
        if ( !batch.course_name_short )
            batch.course_name_short = batch.course_short_name
        batch.id = batch.batch_assignment_id
        batch.entity = 'batch'
        batch.title = `${batch.batch_name}-${batch.course_name_short || ""}${batch.current_year ? ` Y${batch.current_year}` : ``}${batch.current_sem ? ` S${batch.current_sem}` : ``} ${batch.batch_short_name}`
        batch.short_title = `Batch ${batch.batch_name || batch.batch_short_name}${batch.remarks ? `, ${batch.remarks}` : ", Remarks: Not given."}`
        batch.chip_label = `Batch: ${batch.batch_name || batch.batch_short_name}${batch.remarks ? `, ${batch.remarks}` : ", Remarks: Not given."}`
        batch.academic_details = `${batch.ac_year ? `${batch.ac_year},` : ""} ${batch.current_year ? `Year: ${batch.current_year}` : ""}${batch.current_sem ? `, Semester: ${batch.current_sem}` : ""}, Remarks: ${batch.remarks || "Not given."}`
        batch.course_name_short = Array.from( new Set( batch.course_name_short?.split( "," ) ) ).join( ", " )
        return batch
    }
    if ( group?.entity === 'section' || group?.section_assignment_id ) {
        const section = { ...group }
        section.id = `${section.section_assignment_id}-${section.section_short_name}`
        section.entity = 'section'
        section.title = `${section.course_branch_short_name}-${section.course_short_name || ""}${section.current_year ? ` Y${section.current_year}` : ``}${section.current_sem ? ` S${section.current_sem}` : ``} (${section.section_short_name + ")"}`
        section.short_title = `Section ${section.section_short_name}`
        section.chip_label = `Section: ${section.section_short_name} `
        section.academic_details = `${section.ac_year ? `${section.ac_year},` : ""} ${section.current_year ? `Year: ${section.current_year}` : ""}${section.current_sem ? `, Semester: ${section.current_sem}` : ""}, Remarks: ${section.remarks || "Not given."}`
        section.course_name_short = section.course_short_name
        return section
    }
}

export const getCleanSubjectDetails = subject => {
    if ( !subject )
        return null
    return {
        subject_id: subject.subject_id,
        subject_code: subject.subject_code,
        subject_name_short: subject.subject_name_short,
        subject_name: subject.subject_name,
        ac_year_id: subject.ac_year_id,
        ac_year: subject.ac_year,
        year: subject.year,
        sem: subject.sem,
    }
}

export const markdownToText = ( markdown ) => {
    if ( !markdown ) return ''
    return markdown
        .replace( /(\*\*|__)(.*?)\1/g, "$2" ) // Bold
        .replace( /(\*|_)(.*?)\1/g, "$2" )   // Italics
        .replace( /~~(.*?)~~/g, "$1" )       // Strikethrough
        .replace( /`{1,2}([^`]*)`{1,2}/g, "$1" ) // Inline code
        .replace( /!\[.*?\]\((.*?)\)/g, "" ) // Remove images
        .replace( /\[([^\]]+)\]\((.*?)\)/g, "$1" ) // Links: keep text, remove URL
        .replace( /^#{1,6}\s*(.*)/gm, "$1" ) // Headers
        .replace( />\s?(.*)/g, "$1" )       // Blockquotes
        .replace( /[-*+]\s+(.*)/g, "$1" )   // Lists
        .replace( /\n{2,}/g, "\n" )         // Remove extra newlines
        .trim()
}

export const leadingZeroFormatter = new Intl.NumberFormat( undefined, {
    minimumIntegerDigits: 2,
} )

export const getKeyValueFromObject = ( obj, keys ) => {
    if ( typeof keys === 'string' ) {
        return obj ? obj[keys] : undefined
    }

    if ( Array.isArray( keys ) ) {
        return keys.reduce( ( acc, key ) => ( acc ? acc[key] : undefined ), obj )
    }

    return undefined
}

export const isMobileDevice = () => {
    const userAgent = navigator.userAgent.toLowerCase()
    const isMobileUA = /mobile|android|iphone|ipad|phone/i.test( userAgent )
    const isSmallScreen = window.matchMedia( '(max-width: 767px)' ).matches
    return { isMobile: isMobileUA || typeof window?.orientation !== 'undefined' || navigator.userAgent.indexOf( 'IEMobile' ) !== -1, isSmallScreen }
}

export const getBrowserDetails = () => {
    const userAgent = navigator.userAgent
    const language = navigator.language

    let browserName = 'Unknown'
    let fullVersion = 'Unknown'

    if ( userAgent.indexOf( 'Chrome' ) > -1 ) {
        browserName = 'Chrome'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Chrome' ) + 7 )
    } else if ( userAgent.indexOf( 'Firefox' ) > -1 ) {
        browserName = 'Firefox'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Firefox' ) + 8 )
    } else if ( userAgent.indexOf( 'MSIE' ) > -1 || !!document.documentMode ) {
        browserName = 'Internet Explorer'
        fullVersion = userAgent.substring( userAgent.indexOf( 'MSIE' ) + 5 )
    } else if ( userAgent.indexOf( 'Safari' ) > -1 && userAgent.indexOf( 'Chrome' ) === -1 ) {
        browserName = 'Safari'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Safari' ) + 7 )
    } else if ( userAgent.indexOf( 'Opera' ) > -1 || userAgent.indexOf( 'OPR' ) > -1 ) {
        browserName = 'Opera'
        fullVersion = userAgent.substring( userAgent.indexOf( 'Opera' ) + 6 )
    }

    // Extract only the version number (e.g., "96.0" from "96.0.4664.110")
    const version = fullVersion.split( ' ' )[0].split( '.' )[0]

    return {
        userAgent: userAgent,
        language: language,
        browserName,
        fullVersion,
        version,
    }
}

export const boundaryValue = ( min, desired, max ) => {
    if ( desired == null ) {
        return min
    }
    return Math.max( min, Math.min( desired, max ) )
}

export const convertToCDNLink = ( data = "" ) => {
    if ( typeof data !== 'string' || data.includes( "cdn.digitaloceanspaces" ) )
        return data
    return data?.replace( /digitaloceanspaces/, 'cdn.digitaloceanspaces' )
}

export const replaceSpacesesLocationsWithCDNLinks = ( data ) => {
    if ( typeof data === 'string' ) {
        const regex = /https:\/\/[a-z-]+\.[a-zA-Z0-9]+\.digitaloceanspaces\.com\/(?<key>(?!cdn\/)[a-zA-Z_/-]+\/[.a-zA-Z0-9@%()_-\s]+\.\w+\/?)/gm
        const result = data.replace( regex, ( match ) => {
            return match.replace( '.digitaloceanspaces.com', '.cdn.digitaloceanspaces.com' )
        } )
        return result
    } else return data
}

export const extractSpacesLinkFromText = ( data ) => {
    if ( typeof data === 'string' ) {
        const regex = /https:\/\/(?<bucket>[a-z-]+)\.(?<region>[a-zA-Z0-9]+)\.(cdn\.)?digitaloceanspaces\.com\/(?<key>[a-zA-Z_/-]+\/[.a-zA-Z0-9@%()_-\s]+\.\w+\/?)/gm
        const result = Array.from( data.matchAll( regex ) )
        const matched = result.map( ( r ) => r[0] )
        return { matched, matchedWithGroups: result }
    } else return data
}

export const getUniqueStringFromLongString = ( input ) => {
    input = input + ''
    let hash = 0
    for ( let i = 0; i < input.length; i++ ) {
        hash = ( hash << 5 ) - hash + input.charCodeAt( i )
        hash &= hash // Convert to 32-bit integer
    }
    return Math.abs( hash ).toString( 36 ) // Convert to base-36 for compactness
}

export const getFileSizeFromBytes = ( bytes ) => {
    if ( isNaN( bytes ) ) return '-'
    const kb = bytes / 1024
    if ( kb < 1024 ) return `${kb?.toFixed( 2 )} KB`
    else if ( kb / 1024 < 1024 ) return `${( kb / 1024 )?.toFixed( 2 )} MB`
    else return `${( kb / ( 1024 * 1024 ) )?.toFixed( 2 )} GB`
}

export const getCountString = ( count ) => {
    if ( Number.isNaN( +count ) ) return '_'
    if ( count < 1000 ) return count
    const inKilo = count / 1000
    if ( +inKilo < 1000 ) {
        const [whole, decimal = '0'] = ( '' + inKilo ).split( '.' )
        return `${whole}.${decimal[0]}K+`
    }
    const inMil = ( +inKilo / 1000 ).toFixed( 1 )
    const [whole, decimal = '0'] = ( '' + inMil ).split( '.' )
    return `${whole}.${decimal[0]}M+`
}

const createImage = ( url ) =>
    new Promise( ( resolve, reject ) => {
        const image = new Image()
        image.addEventListener( 'load', () => resolve( image ) )
        image.addEventListener( 'error', ( error ) => reject( error ) )
        image.setAttribute( 'crossOrigin', 'anonymous' ) // needed to avoid cross-origin issues on CodeSandbox
        image.src = url
    } )

export const getCroppedImage = async ( imageSrc, pixelCrop ) => {
    const image = await createImage( imageSrc )
    const canvas = document.createElement( 'canvas' )
    const ctx = canvas.getContext( '2d' )

    if ( !ctx ) {
        return null
    }

    const { width: bBoxWidth, height: bBoxHeight } = image

    canvas.width = bBoxWidth
    canvas.height = bBoxHeight

    ctx.translate( bBoxWidth / 2, bBoxHeight / 2 )
    ctx.translate( -image.width / 2, -image.height / 2 )

    ctx.drawImage( image, 0, 0 )

    const data = ctx.getImageData( pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height )

    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height

    ctx.putImageData( data, 0, 0 )

    return await new Promise( ( resolve, reject ) => {
        canvas.toBlob( ( file ) => {
            file.name = 'cropped.jpeg'
            resolve( { file: file, url: URL.createObjectURL( file ) } )
        }, 'image/jpeg' )
    } )
}

export const base64ToFileAndBlob = async ( base64String, fileName, mimeType ) => {
    const byteCharacters = atob( base64String.split( ',' )[1] )

    const byteArray = new Uint8Array( byteCharacters.length )

    for ( let i = 0; i < byteCharacters.length; i++ ) {
        byteArray[i] = byteCharacters.charCodeAt( i )
    }

    const blob = new Blob( [byteArray], { type: mimeType } )

    const file = new File( [blob], fileName, { type: mimeType } )

    return { file, blob }
}

export const extractMimeType = ( base64String ) => {
    const regex = /^data:(image|video|audio|application|text|font)\/([a-zA-Z0-9-+.]+);base64,/
    const match = base64String.match( regex )

    if ( match ) {
        return match[0]?.split( ':' )[1]?.split( ';' )[0]
    } else {
        console.error( 'Invalid base64 data URL' )
        return null
    }
}

export const getCurrentWeek = ( date = new Date() ) => {
    const curr = new Date( date )
    const dday = curr.getDay()
    let week = []
    if ( dday === 0 ) {
        for ( let i = 5; i >= -1; i-- ) {
            let tempCurr = new Date( date )
            let first = tempCurr.getDate() - i
            let day = new Date( tempCurr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
    } else if ( dday !== 0 ) {
        for ( let i = 1; i <= 6; i++ ) {
            let first = curr.getDate() - curr.getDay() + i + 1
            let day = new Date( curr.setDate( first ) ).toISOString().slice( 0, 10 )
            week.push( day )
        }
        week.push( new Date( curr.setDate( curr.getDate() + 1 ) ).toISOString().slice( 0, 10 ) )
    }

    return week
}

export const getTimePassedFrom = ( time ) => {
    const now = Date.now()
    const createdTime = new Date( time ).getTime()
    const diff = ( now - createdTime ) / 1000
    if ( diff < 60 ) return 'Few seconds ago'
    else if ( diff < 60 * 60 ) {
        const count = Math.floor( diff / 60 )
        return `${count} minute${count > 1 ? 's' : ''} ago`
    } else if ( diff < 60 * 60 * 24 ) {
        const count = Math.floor( diff / 3600 )
        return `${count} hour${count > 1 ? 's' : ''} ago`
    } else if ( diff < 31536000 ) {
        const count = Math.floor( diff / ( 3600 * 24 ) )
        return `${count} day${count > 1 ? 's' : ''} ago`
    } else {
        const count = Math.floor( diff / 31536000 )
        return `${count} Year${count > 1 ? 's' : ''} ago`
    }
}

export const getExtraSIfPlural = ( count, esPostfix = false ) => {
    return !( !count || count <= 1 ) ? esPostfix ? "es" : "s" : ""
}

export const getTimePassedFromDetails = ( time ) => {
    const now = Date.now()
    const createdTime = new Date( time ).getTime()
    const diff = ( now - createdTime ) / 1000

    let displayString = ""

    if ( diff < 60 ) displayString = 'Few seconds ago'
    else if ( diff < 60 * 60 ) {
        const count = Math.floor( diff / 60 )
        displayString = `${count} minute${count > 1 ? 's' : ''} ago`
    } else if ( diff < 60 * 60 * 24 ) {
        const count = Math.floor( diff / 3600 )
        displayString = `${count} hour${count > 1 ? 's' : ''} ago`
    } else if ( diff < 31536000 ) {
        const count = Math.floor( diff / ( 3600 * 24 ) )
        displayString = `${count} day${count > 1 ? 's' : ''} ago`
    } else {
        const count = Math.floor( diff / 31536000 )
        displayString = `${count} Year${count > 1 ? 's' : ''} ago`
    }

    return {
        displayString,
        diff,
        h: Math.floor( diff / 3600 ),
        m: Math.floor( ( diff % 3600 ) / 60 ),
        s: Math.floor( ( diff % 3600 ) % 60 ),
    }
}

export const shuffleArray = ( array ) => {
    let currentIndex = array.length,
        randomIndex
    while ( currentIndex !== 0 ) {
        randomIndex = Math.floor( Math.random() * currentIndex )
        currentIndex--
            ;[array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]]
    }

    return array
}

export const mergeArray = ( indexes, arrayList ) => {
    let newArray = []
    for ( let i = 0; i < indexes.length; i++ ) {
        const index = indexes[i]
        newArray = newArray.concat( arrayList[index] )
    }
    return newArray
}

export const formatVideoDuration = ( time ) => {
    let t = Math.abs( time )
    const seconds = Math.floor( t % 60 )
    const minutes = Math.floor( t / 60 ) % 60
    const hours = Math.floor( t / 3600 )
    if ( hours === 0 ) {
        return `${time < 0 ? "-" : ""}${minutes}:${leadingZeroFormatter.format( seconds )}`
    } else {
        return `${time < 0 ? "-" : ""}${hours}:${leadingZeroFormatter.format( minutes )}:${leadingZeroFormatter.format( seconds )}`
    }
}

/**
 * Returns an array of evenly spaced time values across the video duration.
 * Includes the first frame (0) and the last frame (duration) when n > 1.
 *
 * @param {number} duration - Video duration in seconds.
 * @param {number} count - Number of timeline points required.
 * @returns {number[]} Sorted time values from lowest to highest.
 */
export const getTimelineIntervals = ( duration, count, options = {} ) => {

    const { includeExtreams = true } = options

    const totalPoints = Math.max( 0, Math.floor( count + ( !includeExtreams ? 2 : 0 ) ) )
    if ( !Number.isFinite( duration ) || duration <= 0 || totalPoints <= 0 ) return []
    if ( totalPoints === 1 ) return [0]

    const step = duration / ( totalPoints - 1 )
    const intervals = Array.from( { length: totalPoints }, ( _, index ) => {
        const time = index * step
        return Number( time.toFixed( 3 ) )
    } )

    if ( includeExtreams )
        return intervals
    else
        return intervals.slice( 1, -1 )
}

export const secondsToHMS = ( time, showZeroValues = true ) => {
    time = Number( time )
    var h = Math.floor( time / 3600 )
    var m = Math.floor( ( time % 3600 ) / 60 )
    var s = Math.floor( ( time % 3600 ) % 60 )

    if ( showZeroValues )
        return `${leadingZeroFormatter.format( h )}:${leadingZeroFormatter.format( m )}:${leadingZeroFormatter.format( s )}`
    return `${h > 0 ? `${leadingZeroFormatter.format( h )}:` : ""}${leadingZeroFormatter.format( m )}:${leadingZeroFormatter.format( s )}`
}

let debounceTimeoutIds = {}
export const debounce = ( debounceId, func, delay = 500 ) => {
    return ( ...args ) => {
        if ( debounceTimeoutIds[debounceId] ) clearTimeout( debounceTimeoutIds[debounceId] )
        debounceTimeoutIds[debounceId] = setTimeout( () => {
            func.apply( null, args )
        }, delay )
    }
}

export const getMaxValueByKey = ( list, key ) => {
    if ( !Array.isArray( list ) ) throw new Error( `First argument must be an array, reaceived ${typeof list}` )
    return list.reduce( ( max, item ) => ( item[key] > max ? item[key] : max ), 0 )
}

export const sortArrayOfObjectsByKey = ( list, key, order = 1, dataType = "string" ) => {
    if ( dataType === "string" ) {
        const sortedList = [...list]
        sortedList.sort( ( a, b ) => a[key].localeCompare( b[key] ) )
        if ( order === -1 ) sortedList.reverse()
        return sortedList
    } else {
        const sortedList = [...list]
        sortedList.sort( ( a, b ) => a[key] > b[key] ? 1 : -1 )
        if ( order === -1 ) sortedList.reverse()
        return sortedList
    }
}

export const sortByProperty = ( data, setData, property, type, order ) => {
    let newFilteredData = [...data]

    const getNestedProperty = ( obj, keys ) => {
        return keys.reduce( ( acc, key ) => acc && acc[key], obj )
    }

    const keys = property?.split( '.' )
    newFilteredData.sort( ( a, b ) => {
        const aval = getNestedProperty( a, keys )
        const bval = getNestedProperty( b, keys )

        if ( type === 'number' ) {
            if ( order === '1' ) {
                return parseInt( aval ) - parseInt( bval )
            } else {
                return parseInt( bval ) - parseInt( aval )
            }
        } else {
            if ( order === '1' ) {
                return aval?.localeCompare( bval, undefined, { sensitivity: 'base' } )
            } else {
                return bval?.localeCompare( aval, undefined, { sensitivity: 'base' } )
            }
        }
    } )
    setData( newFilteredData )
}

export const generateFlatColors = ( numColors = 5 ) => {
    const colors = []

    for ( let i = 0; i < numColors; i++ ) {
        const hue = ( ( i * 360 ) / numColors ) % 360
        const saturation = 65 + Math.floor( Math.random() * 10 ) // Around 65-75%
        const lightness = 55 + Math.floor( Math.random() * 10 ) // Around 55-65%

        colors.push( `hsl(${hue}, ${saturation}%, ${lightness}%)` )
    }

    return colors
}

// Report export functions
export const exportAssignmentReport = async ( assignments, noAttemptStudentListIncluded ) => {
    const head = [
        { fontWeight: 'bold', value: 'Sl.No.', width: 10, align: "center", borderColor: "#000000" },
        { fontWeight: 'bold', value: 'AUID', width: 15, borderColor: "#000000" },
        { fontWeight: 'bold', value: 'USN', width: 15, borderColor: "#000000" },
        { fontWeight: 'bold', value: 'Student Name', width: 70, borderColor: "#000000" },
        { fontWeight: 'bold', value: 'Submitted On', width: 25, borderColor: "#000000" },
        { fontWeight: 'bold', value: 'Score', width: 10, align: "center", borderColor: "#000000" },
    ]
    let data = []
    data.push( head )
    assignments.forEach( ( item, i ) => {
        let row = []
        row.push( { value: i + 1, type: Number, backgroundColor: item.no_submission ? '#ff5555' : undefined, align: "center" } )
        row.push( { value: item.assignment_submitted_by, type: String, backgroundColor: item.no_submission ? '#ff5555' : undefined } )
        row.push( { value: item.student_usn, type: String, backgroundColor: item.no_submission ? '#ff5555' : undefined } )
        row.push( { value: item.student_name, type: String, backgroundColor: item.no_submission ? '#ff5555' : undefined } )
        row.push( { value: item.assignment_submitted_on || "Not Submitted", type: String, backgroundColor: item.no_submission ? '#ff5555' : undefined } )
        row.push( { value: item.assignment_marks || "-", type: String, backgroundColor: item.no_submission ? '#ff5555' : undefined, align: "center" } )
        data.push( row )
    } )

    if ( !noAttemptStudentListIncluded ) {
        const customMessage = "The batch or section assigned to this resource belongs to a previous academic year and is no longer active, so the list of students who did not attempt this exam cannot be displayed."

        data.push( [
            {
                value: customMessage,
                span: head.length,
                fontWeight: "bold",
                backgroundColor: "#FFFF00"
            },
            ...new Array( head.length - 1 ).fill( null ),
        ] )
    }

    const excelFile = await writeXlsxFile( data, { columns: data[0], buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `assignment-${assignments[0].assignment_id}-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

export const exportStudyMaterialsReport = async ( stats, map, institute ) => {
    const head = [
        { fontWeight: 'bold', value: 'Sl.No.' },
        { fontWeight: 'bold', value: 'Faculty Name' },
        { fontWeight: 'bold', value: 'Faculty ID' },
        { fontWeight: 'bold', value: 'Institute Department' },
        { fontWeight: 'bold', value: 'Study Materials' },
        { fontWeight: 'bold', value: 'Documents' },
        { fontWeight: 'bold', value: 'Downloads' },
    ]
    let data = []
    data.push( head )
    stats.forEach( ( item, i ) => {
        let row = []
        row.push( { value: i + 1, type: Number } )
        row.push( { value: item.study_material_created_by, type: String } )
        row.push( { value: item.empcode, type: String } )
        row.push( { value: `${institute}-${map[item.empcode]}`, type: String } )
        row.push( { value: item.material_count, type: String } )
        row.push( { value: item.attachment_count, type: String } )
        row.push( { value: item.sum, type: String } )
        data.push( row )
    } )
    const excelFile = await writeXlsxFile( data, { buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `studyMaterial-${institute}-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

export const exportAttendanceReport = async ( attendanceData, fromDate, toDate ) => {
    const head = [
        { fontWeight: 'bold', value: 'Date' },
        { fontWeight: 'bold', value: 'Subject' },
        { fontWeight: 'bold', value: 'Institute' },
        { fontWeight: 'bold', value: 'Branch' },
        { fontWeight: 'bold', value: 'Presenter' },
        { fontWeight: 'bold', value: 'Duration' },
        { fontWeight: 'bold', value: 'Attendance' },
    ]
    let data = []
    data.push( head )
    attendanceData.forEach( ( item, i ) => {
        let row = []
        row.push( { value: item.selected_date, type: String } )
        row.push( { value: item.subject_name_short, type: String } )
        row.push( { value: item.institute, type: String } )
        row.push( { value: item.branch_name, type: String } )
        row.push( { value: item.presenter, type: String } )
        row.push( { value: item.duration, type: String } )
        row.push( { value: item.attendance, type: Number } )
        data.push( row )
    } )
    const excelFile = await writeXlsxFile( data, { buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `attendance-report(${fromDate}-${toDate}).xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

export const exportMeetingAttendanceReport = async ( meetingDetails, attendance, videoWatchAttendance = [], quizParticipants = [] ) => {
    try {
        const head = [
            { fontWeight: 'bold', value: 'SL.NO.' },
            { fontWeight: 'bold', value: 'Name' },
            { fontWeight: 'bold', value: 'AUID/USER ID/EMAIL ID' },
        ]

        if ( meetingDetails.meeting_type === "hybrid-class" ) {
            head.push(
                { fontWeight: 'bold', value: 'Watched Video' },
                { fontWeight: 'bold', value: 'Quiz Attempted' },
                { fontWeight: 'bold', value: 'Video Watched %' },
            )
        } else {
            head.push(
                { fontWeight: 'bold', value: 'Attended Class' },
                { fontWeight: 'bold', value: 'TIME SPENT (HH:MM:SS)' }
            )
        }

        head.push( { fontWeight: 'bold', value: 'Present Status' } )

        let data = []
        data.push( head )
        attendance.forEach( ( item, i ) => {

            let row = []

            const didUserWatchVideos = videoWatchAttendance?.find( u => u.user_id === item.user_id )
            const quizAttempted = quizParticipants?.find( u => u === item.user_id )

            row.push( { value: i + 1, type: Number } )
            row.push( { value: item.name, type: String } )
            row.push( { value: item.user_id, type: String } )

            if ( meetingDetails.meeting_type === "hybrid-class" ) {
                row.push(
                    { type: String, value: String( Boolean( didUserWatchVideos ) ) },
                    { type: String, value: String( Boolean( quizAttempted ) ) },
                    { type: String, value: `${didUserWatchVideos ? Math.round( didUserWatchVideos.average ) : 0}` },
                )
            } else {
                row.push(
                    { type: String, value: "true" },
                    { value: secondsToHMS( item.total_time / 1000 ), type: String }
                )
            }

            row.push( { value: item.present || didUserWatchVideos?.present ? "Present" : "Absent", type: String } )

            data.push( row )
        } )

        if ( meetingDetails.meeting_type === "hybrid-class" && videoWatchAttendance.length > 0 ) {
            videoWatchAttendance.forEach( ( item, index ) => {

                const didUserStreamClass = attendance?.find( u => u.user_id === item.user_id )
                if ( didUserStreamClass )
                    return

                let row = []
                const quizAttempted = quizParticipants?.find( u => u === item.user_id )

                row.push( { value: ( attendance?.length || 0 ) + index + 1, type: Number } )
                row.push( { value: item.name, type: String } )
                row.push( { value: item.user_id, type: String } )

                row.push(
                    { type: String, value: "true" },
                    { type: String, value: String( Boolean( quizAttempted ) ) },
                    { type: String, value: `${item ? Math.round( item.average ) : 0}%` },
                )

                row.push( { value: item?.present ? "Present" : "Absent", type: String } )
                data.push( row )
            } )
        }

        const excelFile = await writeXlsxFile( data, { buffer: true } )
        const blob = new Blob( [excelFile] )
        const a = document.createElement( 'a' )
        a.download = `attendance-report(${meetingDetails.title}-${formatDate( meetingDetails.starts_at )}).xlsx`
        a.href = window.URL.createObjectURL( blob )
        a.click()
    } catch ( err ) {
        toast( "Failed to export attendance details! try again later" )
        console.log( err )
    }
}

export const exportAcademicProgressReport = async ( stats, nameDetails ) => {
    const head = [
        { fontWeight: 'bold', value: 'Sl.No.' },
        { fontWeight: 'bold', value: 'AUID' },
        { fontWeight: 'bold', value: 'Name' },
        { fontWeight: 'bold', value: 'Required count' },
        { fontWeight: 'bold', value: 'Pending Count' },
        { fontWeight: 'bold', value: 'Pending data' },
        { fontWeight: 'bold', value: 'Required Progress' },
        { fontWeight: 'bold', value: 'Total Progress' },
    ]
    let data = []
    data.push( head )
    stats.forEach( ( item, i ) => {
        let row = []
        row.push( { value: i + 1, type: Number } )
        row.push( { value: item.auid, type: String } )
        row.push( { value: item.student_name, type: String } )
        row.push( { value: item.requiredChecklistItemsCount, type: Number } )
        row.push( { value: item.pendingCount, type: Number } )
        row.push( { value: item.pendingItems?.map( ( i ) => i.input_label )?.join( ', ' ), type: String } )
        row.push( { value: item.requiredItemsCompletionPercentage, type: Number } )
        row.push( { value: item.totalProgress, type: Number } )
        data.push( row )
    } )

    let name = `${nameDetails.branch.institute_name_short}-${nameDetails.branch.course_branch_short_name}-${nameDetails.academicYear}`
    const excelFile = await writeXlsxFile( data, { buffer: true } )
    const blob = new Blob( [excelFile] )
    const a = document.createElement( 'a' )
    a.download = `${name}-academic-progress-report.xlsx`
    a.href = window.URL.createObjectURL( blob )
    a.click()
}

export const formatDate = ( datetime, formatOptions = {}, adjustValue = { minutes: 0, hours: 0, seconds: 0 } ) => {
    if ( datetime ) {
        datetime = dayjs( datetime )
        if ( typeof adjustValue !== 'object' ) datetime = datetime.add( +( adjustValue || 0 ), 'minutes' )
        else
            datetime = datetime
                .add( adjustValue.hours || 0, 'hours' )
                .add( adjustValue.minutes || 0, 'minutes' )
                .add( adjustValue.seconds || 0, 'seconds' )
        if ( formatOptions.showTime ) {
            let timeString = datetime.format( 'h:mm a' )
            datetime = datetime.toString()
            return new Date( datetime ).toLocaleDateString( formatOptions.regionCode || 'en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', ...formatOptions } ).replace( /\//g, formatOptions.separator || '-' ) + ` ${timeString}`
        } else if ( formatOptions.format ) {
            return datetime.format( formatOptions.format )
        } else {
            datetime = datetime.toString()
            return new Date( datetime ).toLocaleDateString( formatOptions.regionCode || 'en-IN', { day: '2-digit', month: '2-digit', year: 'numeric', ...formatOptions } ).replace( /\//g, formatOptions.separator || '-' )
        }
    }
    return ''
}

export const adjustDate = ( datetime, adjustValue = { minutes: 0, hours: 0, seconds: 0 } ) => {
    if ( datetime ) {
        datetime = dayjs( datetime )
        if ( typeof adjustValue !== 'object' ) datetime = datetime.add( +( adjustValue || 0 ), 'minutes' )
        else
            datetime = datetime
                .add( adjustValue.hours || 0, 'hours' )
                .add( adjustValue.minutes || 0, 'minutes' )
                .add( adjustValue.seconds || 0, 'seconds' )
        datetime = datetime.toString()
        return new Date( datetime )
    }
    return ''
}

export const getClassTitle = ( room ) => {
    try {
        const sectionOrBatch = room?.batch_short_name && room?.batch_short_name !== "NA"
            ? `Batch ${room.batch_short_name}`
            : `Section ${room?.section_short_name}`
        let course = new Set( room.course_short_name?.split( "," )?.map( c => c?.trim() ).filter( c => !!c ) )
        course = Array.from( course ).join( "," )
        return `${room?.subject_name_short} for ${course}:${sectionOrBatch} by ${room?.presenter_name} (${formatDate( room?.selected_date, { format: "DD-MM-YYYY" } )})`.trim().replace( /[-\s]+$/g, "" ).slice( 0, 240 )
    } catch ( err ) {
        console.log( 'ERROR', err )
        return `${room?.subject_name_short}-${room?.presenter_name}`
    }
}

export const getClassQuizTitle = ( room ) => {
    try {
        return `${room?.subject_name_short} Quiz - ${formatDate( room?.selected_date, { format: "DD-MM-YYYY" } )}`
    } catch ( err ) {
        console.log( 'ERROR', err )
        return `${room?.subject_name_short}-${room?.presenter_name}`
    }
}

export const QUIZ_DURATION_OPTIONS = [
    { value: '00:05', label: '5 min' },
    { value: '00:10', label: '10 min' },
    { value: '00:15', label: '15 min' },
    { value: '00:20', label: '20 min' },
    { value: '00:30', label: '30 min' },
]

export const getDurationInHHMM = ( start, end ) => {
    try {
        const normalise = ( t ) => {
            if ( typeof t !== 'string' ) {
                const date = new Date( t )
                if ( !isNaN( date ) ) return date.toLocaleTimeString( 'en-IN', { hourCycle: "h24", hour: "2-digit", minute: "2-digit" } )
                return t
            }
            const match = t.match( /(\d{1,2}):(\d{2})/ )
            if ( !match ) return t
            return match[1].padStart( 2, "0" ) + ":" + match[2]
        }
        const s = normalise( start )
        const e = normalise( end )
        const startMin = +s.split( ":" )[0] * 60 + +s.split( ":" )[1]
        const endMin = +e.split( ":" )[0] * 60 + +e.split( ":" )[1]
        const diff = Math.max( 0, endMin - startMin )
        return `${String( Math.floor( diff / 60 ) ).padStart( 2, "0" )}:${String( diff % 60 ).padStart( 2, "0" )}`
    } catch ( err ) {
        console.log( 'ERROR', err )
        return "00:00"
    }
}

export const isIOS = () => {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes( window.navigator?.userAgentData?.platform ) || ( navigator.userAgent.includes( 'Mac' ) && 'ontouchend' in document )
}

export const time24to12 = ( time ) => {
    try {
        if ( time ) {
            const formatedTime = new Date( `2024-01-01 ${time}` ).toLocaleTimeString( 'en-IN', { hour: '2-digit', minute: '2-digit' } )
            if ( formatedTime !== 'Invalid Date' ) return formatedTime.toUpperCase()
            else return ''
        } else return ''
    } catch ( err ) {
        console.log( 'ERROR', err )
        return time
    }
}
